import { useQuery } from 'hooks/useCustomQuery';
import getCompanyServices from '@/API/getCompanyServices';

const useGetCompanyServices = (companyId) => {
    return useQuery({
        queryKey: ['services', `company: ${companyId}`],
        queryFn: async () => {
            const response = await getCompanyServices(companyId);
            return response.data;
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
        enabled: !!companyId,
    });
};

export default useGetCompanyServices;
